<template>
    <DropDownButton 
        id="sort" 
        label="Sort" 
        prefix-icon 
        icon-name="sort"
        icon-width="16px" 
        variant="outline"
        variant-style="secondary" 
        :size="size"
        :is-content="value && !!value.length"
    >
        <span v-if="value.length" class="text-gray-400 text--semi--bold ml--5 text--xs">1</span>
        <template #dropdown-content>
            <ListItem
                v-for="(item, index) in displayTypeList" 
                :key="index" 
                pointer
                :class="{ 'selected': value === item }"
                class="text--sm flex align-items-center" 
                @click="setDisplayType(item)"
            >
                {{ labelValue }} ({{ item }})

                <span v-if="value === item" class="group__active ml--3">
                    <IconSvg name="check" fill="#64748B" width="16px" height="16px" />
                </span>
            </ListItem>
        </template>
    </DropDownButton>
</template>

<script>
import DropDownButton from "../buttons/DropDownButton.vue";
import IconSvg from "../icons/Icon-Svg.vue";
import ListItem from "../lists/ListItem.vue";

export default {
    name: "SortFilter",

    components: { DropDownButton, IconSvg, ListItem },
    
    props: {
        value: {
            type: String,
            default: "Ascending",
        },
        size: { 
            type: String, 
            default: "sm",
            validator: (value) => {
                return ["xs", "sm", "md", "lg"].includes(value);
            },
        },
        labelValue: {
            type: String,
            default: "",
            required: true,
        },
    },
    
    data() {
        return {
            displayTypeList: ["Ascending", "Descending"],
        };
    },

    methods: {
        setDisplayType(val) {
            this.$emit("setType", val);
            setTimeout(() => {
                document.getElementById("sortFilter").classList.remove("show");
                document.getElementById("sortFilterList").classList.remove("show");
            }, 100);
        },
    },
};
</script>